import { render, staticRenderFns } from "./xieyi.vue?vue&type=template&id=5565ff59&scoped=true&"
import script from "./xieyi.vue?vue&type=script&lang=js&"
export * from "./xieyi.vue?vue&type=script&lang=js&"
import style0 from "./xieyi.vue?vue&type=style&index=0&id=5565ff59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5565ff59",
  null
  
)

export default component.exports